/* eslint-disable @typescript-eslint/naming-convention */

import React from 'react';

import { SearchFilter } from 'common/components/SearchFilter';
import { useTranslation } from 'common/hooks/useTranslation';
import { PayableFilterBuilder } from 'src/core/modules/payable/components';

import type {
  FiltersState,
  FilterActions,
} from '../../containers/PayablesFiltersContainer/hooks/useFiltersContext';

type Props = {
  state: FiltersState;
  actions: FilterActions;
};

export const PayablesFilters = ({ state, actions }: Props) => {
  const { t } = useTranslation('global');

  return (
    <div className="relative z-[9] my-24 flex items-center gap-8 bg-background-primary-default">
      <SearchFilter
        search={state.search ?? ''}
        setSearch={actions.setSearch}
        placeholder={t('payables.filters.searchPlaceholder')}
      />

      <PayableFilterBuilder variant="all-payables" />
    </div>
  );
};
